import { useNavigate } from "react-router-dom";
import { BackButton } from "../../../components/features/BackButton";
import { paths } from "../../../config/paths";
import { BeautyServiceCard } from "../../../features/beauty-services/components/BeautyServiceCard";
import { fragranceBeautyServices } from "../../../features/beauty-services/data/fragranceBeautyServices";
import { makeupBeautyServices } from "../../../features/beauty-services/data/makeupBeautyServices";

export const BeautyServices = () => {
  const navigate = useNavigate();
  return (
    <div
      className="flex flex-col overflow-y-auto h-full"
      style={{
        background: "linear-gradient(180deg, #FAF5F1 0%, #F5EEEB 100%)",
      }}
    >
      <div className="absolute top-4 left-4 z-10 text-white w-fit">
        <BackButton onClick={() => navigate(paths.looksGallery.path)} />
      </div>
      <div className="flex flex-col gap-6 py-6 items-center">
        <img
          src="/looks-gallery/beauty-services/home.jpg"
          alt="/looks-gallery/beauty-services/home.jpg"
          className="object-contain"
        />
        <div className="flex flex-col gap-6">
          <div className="flex flex-col px-6 items-center">
            <h2 className="text-[#CE0A2C] text-center font-garamond-italic text-[24px] italic font-normal">
              Christian Louboutin
            </h2>
            <h1 className="text-[#050505] text-center font-bebas-kai text-[40px] font-normal">
              Beauty services
            </h1>
          </div>

          <div className="flex flex-col gap-4 px-4">
            <h2 className="flex justify-center items-center gap-6 self-stretch font-garamond-italic text-[22px] font-normal">
              Makeup
            </h2>
            {makeupBeautyServices.map((service) => (
              <BeautyServiceCard key={service.title} {...service} />
            ))}
          </div>
          <div className="flex flex-col gap-4 px-4">
            <h2 className="flex justify-center items-center gap-6 self-stretch font-garamond-italic text-[22px] font-normal">
              Fragrance
            </h2>
            {fragranceBeautyServices.map((service) => (
              <BeautyServiceCard key={service.title} {...service} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
